import { useMemo } from 'react';
import { useQuery } from '@apollo/react-hooks';
import GET_SUBMISSION_STATUSES_BY_CASES from '../../../../graphql/getSubmissionStatusesByCases';
import { INVENTORY_REQUEST_DETAIL_UI } from '../../../../util/constants';
import { SubmissionStatusRecord } from '../../../../util/submissionStatus';

type SubmissionStatusByCaseRecord = SubmissionStatusRecord & {
  caseExternalId?: string | null;
};

interface UseSubmissionStatusesResult {
  submissionStatusByCase: Record<string, SubmissionStatusRecord>;
  error?: Error;
}

const useSubmissionStatuses = (
  caseExternalIds: string[],
  enabled = true
): UseSubmissionStatusesResult => {
  const { data: submissionStatusesData, error } = useQuery(GET_SUBMISSION_STATUSES_BY_CASES, {
    fetchPolicy: 'no-cache',
    skip: !enabled || caseExternalIds.length === 0,
    pollInterval:
      enabled && caseExternalIds.length > 0
        ? INVENTORY_REQUEST_DETAIL_UI.SUBMISSION_POLL_INTERVAL_MS
        : 0,
    variables: { caseExternalIds },
  });

  const submissionStatusByCase = useMemo(() => {
    const statusMap: Record<string, SubmissionStatusRecord> = {};
    (submissionStatusesData?.getSubmissionStatusesByCases || []).forEach(
      (entry: SubmissionStatusByCaseRecord) => {
        if (entry?.caseExternalId) {
          statusMap[entry.caseExternalId] = entry;
        }
      }
    );
    return statusMap;
  }, [submissionStatusesData]);

  return { submissionStatusByCase, error };
};

export default useSubmissionStatuses;
